enum Bank {
  None = -1,
  HandelsBanken = 1,
  SEB,
  NordeaBank,
  ResursBank,
  DanskeBank,
  AvanzaBank,
}

export enum Settelment {
  NotDetermined,
  Liquidation,
  Fusion,
}

export interface Company {
  companyName: string;
  organizationNumber: string;
  organizationAddress: string;
  postalCode: string;
  postOffice: string;
  numberShares: number;
  lowestCapital: number;
  highestCapital: number;
  lowestNumberShares: number;
  highestNumberShares: number;
}

export { Bank };
